import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, trackCallConversion } from '../utils/phone';
const pageLinks = [{
  to: '/services',
  label: 'Services'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/specials',
  label: 'Specials'
}, {
  to: '/gallery',
  label: 'Gallery'
}, {
  to: '/reviews',
  label: 'Reviews'
}, {
  to: '/contact',
  label: 'Contact'
}, {
  to: '/faq',
  label: 'FAQ'
}];
const serviceLinks = [{
  to: '/full-detail',
  label: 'Full Detail'
}, {
  to: '/wash-wax',
  label: 'Wash & Wax'
}, {
  to: '/basic-wash',
  label: 'Basic Wash'
}, {
  to: '/services/interior-detailing',
  label: 'Interior Detailing'
}, {
  to: '/services/hybrid-ceramic-spray',
  label: 'Hybrid Ceramic Spray'
}, {
  to: '/services/headlight-restoration',
  label: 'Headlight Restoration'
}, {
  to: '/services/engine-bay-detailing',
  label: 'Engine Bay Detailing'
}];
const areaLinks = [['camarillo', 'Camarillo'], ['oxnard', 'Oxnard'], ['ventura', 'Ventura'], ['thousand-oaks', 'Thousand Oaks'], ['simi-valley', 'Simi Valley'], ['moorpark', 'Moorpark'], ['newbury-park', 'Newbury Park'], ['westlake-village', 'Westlake Village']];
export function SiteFooter() {
  return <footer className="w-full bg-zinc-950 border-t border-zinc-900 px-4 pt-14 pb-8 text-sm text-gray-400" data-id="element-514" data-mp="vuih89t62jo5">
      <div className="max-w-7xl mx-auto" data-id="element-515" data-mp="10tv1qnwkfenk">
        <div className="grid grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-x-8 gap-y-10" data-id="element-516" data-mp="1ogthfjcv2ikf">
          <div className="col-span-2 lg:col-span-1" data-id="element-517" data-mp="1tgzbt7aimj67">
            <Link to="/" className="text-2xl font-black uppercase tracking-tight" data-id="element-518" data-mp="1tfo79598x7e1">
              <span className="text-white" data-id="element-519" data-mp="1er0grde9bnuy">Mike's</span>{' '}
              <span className="text-red-600" data-id="element-520" data-mp="1jq4nzyhmfbin">Pro Detail</span>
            </Link>
            <p className="mt-1 text-gray-300 font-bold uppercase tracking-wider text-xs" data-id="element-521" data-mp="27g7dq7y2c5e3">
              Mobile Detailing
            </p>
            <p className="mt-4 max-w-xs leading-relaxed" data-id="element-522" data-mp="2c7z6mp4oyn7e">
              Professional mobile car detailing throughout Ventura County and
              select surrounding areas. We come to your home, office, or
              anywhere convenient.
            </p>
            <a href={PHONE_HREF} onClick={trackCallConversion} className="mt-5 inline-flex items-center gap-3 text-white hover:text-yellow-400 transition-colors duration-150" data-id="element-523" data-mp="2d27xnan9wa5h">
              <Phone className="w-5 h-5 text-red-500 shrink-0" aria-hidden="true" data-id="element-524" data-mp="28594aubfo78c" />
              <span data-id="element-525" data-mp="235mp4fc1ogww">
                <span className="block text-xs uppercase tracking-wider text-gray-500 font-bold" data-id="element-526" data-mp="2364t5y4y7zfd">
                  Call or Text
                </span>
                <span className="text-xl font-black whitespace-nowrap" data-id="element-527" data-mp="1tfa8uzb9j9wk">
                  {PHONE_DISPLAY}
                </span>
              </span>
            </a>
          </div>

          <FooterColumn title="Pages" links={pageLinks} data-id="element-528" data-mp="1ke3q0jl55n05" />
          <FooterColumn title="Services" links={serviceLinks} data-id="element-529" data-mp="1kfn5w92vxw1e" />
          <FooterColumn title="Service Areas" links={areaLinks.map(([slug, label]) => ({
          to: `/mobile-detailing-${slug}`,
          label
        }))} data-id="element-530" data-mp="1ffiomgu5kxa4" />
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between gap-4 text-gray-500" data-id="element-531" data-mp="3w0e85c58moi9">
          <p data-id="element-532" data-mp="4vxpamk471rb">
            © {new Date().getFullYear()} Mike's Pro Detail — Mobile Car
            Detailing in Ventura County, California. All rights reserved.
          </p>
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-533" data-mp="38bv08xq3odqp">
            <li data-id="element-534" data-mp="3898k49p58pwv">
              <a href="https://share.google/k4UimfxXqCgBa74jP" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors duration-150" data-id="element-535" data-mp="3dafrw8radp3j">
                Google Reviews
              </a>
            </li>
            <li data-id="element-536" data-mp="3m3rpmu0dw9je">
              <a href="https://www.bbb.org/search?find_text=Mike%27s+Pro+Detail&find_loc=Ventura+County%2C+CA" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors duration-150" data-id="element-537" data-mp="3m4awnfohxdin">
                Better Business Bureau
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  links
}: {
  title: string;
  links: {
    to: string;
    label: string;
  }[];
}) {
  return <nav aria-label={`Footer ${title}`} data-id="element-538" data-mp="2k7veli7a7xdr">
      <h2 className="text-white font-bold uppercase tracking-wider text-xs mb-4" data-id="element-539" data-mp="2k8y5hq4ltzto">
        {title}
      </h2>
      <ul className="space-y-2.5" data-id="element-540" data-mp="2fetxd3jlrlr0">
        {links.map(link => <li key={link.to} data-id="element-541" data-mp="2t7a52hng87y9">
            <Link to={link.to} className="hover:text-yellow-400 transition-colors duration-150" data-id="element-542" data-mp="2t6gut6pa70bd">
              {link.label}
            </Link>
          </li>)}
      </ul>
    </nav>;
}